import * as i0 from '@angular/core';
import { Component, Input, NgModule } from '@angular/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1 from '@ngx-translate/core';
import * as i3 from '@fgb/portal-component-library/src/lib/pipes';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';

class ShortLongDescriptionComponent {
    constructor(translate) {
        this.translate = translate;
        this.descriptionLength = 160;
        this.descriptionLengthMobile = 80;
        this.isMobileSize = false;
        this.isShowingFull = false;
        this.isShowingToggleButton = false;
    }
    ngOnChanges(changes) {
        if (changes) {
            this.handleDescription();
        }
    }
    handleDescription() {
        const MOBILE_SCREEN_SIZE_L = 425;
        this.isMobileSize = window.innerWidth <= MOBILE_SCREEN_SIZE_L;
        // ** Mobile size implementation
        if (this.isMobileSize && this.descriptionLengthMobile) {
            if (this.descriptionLengthMobile) {
                this.descriptionLengthByScreenSize = this.descriptionLengthMobile;
            }
        }
        // ** Desktop size implementation
        else {
            this.descriptionLengthByScreenSize = this.descriptionLength;
        }
        // ** Toggle button implementation
        if (this.descriptionLengthByScreenSize < this.description?.length) {
            this.isShowingToggleButton = true;
        }
    }
    toggleDisplayingOption() {
        this.isShowingFull = !this.isShowingFull;
    }
    get toggleButtonContent() {
        return this.translate.instant(`long.short.description.show.${this.isShowingFull ? 'less' : 'more'}.button`);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ShortLongDescriptionComponent, deps: [{ token: i1.TranslateService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ShortLongDescriptionComponent, selector: "fgbcl-short-long-description", inputs: { description: "description", descriptionLength: "descriptionLength", descriptionLengthMobile: "descriptionLengthMobile" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"short-long\">\r\n  <div class=\"content\">\r\n    <ng-container *ngIf=\"!isShowingFull; else showingFull\">\r\n      <div class=\"short-long-description-text\" [innerHtml]=\"description | truncate : descriptionLengthByScreenSize : '...' : 'html' | safeHtml\"></div>\r\n    </ng-container>\r\n    <ng-template #showingFull>\r\n      <div class=\"short-long-description-text\" [innerHtml]=\"description | safeHtml\"></div>\r\n    </ng-template>\r\n  </div>\r\n\r\n  <div class=\"btn btn-toggle\" *ngIf=\"isShowingToggleButton\" (click)=\"toggleDisplayingOption()\">\r\n    {{ toggleButtonContent }}\r\n  </div>\r\n</div>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i3.SafeHtmlPipe, name: "safeHtml" }, { kind: "pipe", type: i3.TruncatePipe, name: "truncate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ShortLongDescriptionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fgbcl-short-long-description', template: "<div class=\"short-long\">\r\n  <div class=\"content\">\r\n    <ng-container *ngIf=\"!isShowingFull; else showingFull\">\r\n      <div class=\"short-long-description-text\" [innerHtml]=\"description | truncate : descriptionLengthByScreenSize : '...' : 'html' | safeHtml\"></div>\r\n    </ng-container>\r\n    <ng-template #showingFull>\r\n      <div class=\"short-long-description-text\" [innerHtml]=\"description | safeHtml\"></div>\r\n    </ng-template>\r\n  </div>\r\n\r\n  <div class=\"btn btn-toggle\" *ngIf=\"isShowingToggleButton\" (click)=\"toggleDisplayingOption()\">\r\n    {{ toggleButtonContent }}\r\n  </div>\r\n</div>\r\n" }]
        }], ctorParameters: () => [{ type: i1.TranslateService }], propDecorators: { description: [{
                type: Input
            }], descriptionLength: [{
                type: Input
            }], descriptionLengthMobile: [{
                type: Input
            }] } });

class ShortLongDescriptionModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ShortLongDescriptionModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: ShortLongDescriptionModule, declarations: [ShortLongDescriptionComponent], imports: [CommonModule, PipesModule], exports: [ShortLongDescriptionComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ShortLongDescriptionModule, imports: [CommonModule, PipesModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ShortLongDescriptionModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ShortLongDescriptionComponent],
                    imports: [CommonModule, PipesModule],
                    exports: [ShortLongDescriptionComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { ShortLongDescriptionComponent, ShortLongDescriptionModule };
